Modal = require './Modal'

class ErrorModal extends Modal

  constructor: ->
    @init()

  init: ->
    errorModal = _.template app.tpl.errorModal
    $(document.body).append(errorModal())
    super("#errorModal")
    @$modal.find('#errorModalClose').on 'click', => @hide()

  alert: (message)->
    @$modal.find('.modal_content_body p').html(message)
    @show()

module.exports = ErrorModal


// WEBPACK FOOTER //
// ./src/scripts/modules/ErrorModal.coffee